<template>
  <Disclosure as="header" class="bg-deep-purple relative z-40" v-slot="{ open }">
    <div class="max-w-7xl mx-auto px-2 sm:px-4 lg:divide-y lg:divide-gray-700 lg:px-8">
      <div class="relative h-16 flex justify-between">
        <div class="relative z-10 px-2 flex lg:px-0">
          <a href="/" class="flex-shrink-0 flex items-center">
            <img class="block h-8 w-auto" src="/img/site/ezlogo3.png"
                 alt="Edzil.la"/>
          </a>
        </div>

        <div v-if="1===0" class="relative z-0 flex-1 px-2 flex items-center justify-center sm:absolute sm:inset-0">
          <div class="w-full sm:max-w-xs">
            <label for="search" class="sr-only">Search</label>
            <div class="relative">
              <div class="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center">
                <SearchIcon class="h-5 w-5 text-gray-400" aria-hidden="true"/>
              </div>
              <input id="search" name="search"
                     class="block w-full bg-gray-700 border border-transparent rounded-md py-2 pl-10 pr-3 text-sm placeholder-gray-400 focus:outline-none focus:bg-white focus:border-white focus:ring-white focus:text-gray-900 focus:placeholder-gray-500 sm:text-sm"
                     placeholder="Search" type="search"/>
            </div>
          </div>
        </div>
        <div class="relative z-10 flex items-center lg:hidden">
          <SearchModal class="p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded-md lg:hidden" />
          <template v-if="isMember">
            <a href='/live'
               class="bg-yellow-500 text-black mr-4
               rounded-md py-2 px-3 inline-flex items-center text-sm font-medium">Live</a>
          </template>
          <a href="/dash/session/favorites"
             class="bg-gray-800 flex-shrink-0 rounded-full p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
            <span class="sr-only">View favorites</span>
            <HeartIcon class="h-6 w-6" aria-hidden="true"/>
          </a>
          <!-- Hamburger Menu -->
          <DisclosureButton
              class="rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
            <span class="sr-only">Open menu</span>
            <MenuIcon v-if="!open" class="block h-6 w-6" aria-hidden="true"/>
            <XIcon v-else class="block h-6 w-6" aria-hidden="true"/>
          </DisclosureButton>
          <!-- Always-visible Search Icon on Mobile -->

        </div>

<!--        <div v-if="isMember" class="hidden lg:relative lg:z-10 lg:ml-4 lg:flex lg:items-center">
          <a href="/dash/session/favorites"
              class="bg-gray-800 flex-shrink-0 rounded-full p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
            <span class="sr-only">View favorites</span>
            <HeartIcon class="h-6 w-6" aria-hidden="true"/>
          </a>


          <Menu as="div" class="flex-shrink-0 relative ml-4">
            <div>
              <MenuButton
                  class="bg-gray-800 rounded-full flex text-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                <span class="sr-only">Open user menu</span>
                <img class="h-8 w-8 rounded-full" :src="imageUrl" alt=""/>
              </MenuButton>
            </div>
            <transition enter-active-class="transition ease-out duration-100"
                        enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                        leave-active-class="transition ease-in duration-75"
                        leave-from-class="transform opacity-100 scale-100"
                        leave-to-class="transform opacity-0 scale-95">
              <MenuItems
                  class="menu-dropdown origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 py-1 focus:outline-none">
                <MenuItem v-for="item in userNavigation" :key="item.id" v-slot="{ active }">
                  <hr v-if="item.divider">
                  <a v-else-if="item.post" @click="postRequest(item.post)" :href="item.href"
                     :className="item.id"
                     :class="[active ? 'bg-gray-100' : '', 'block py-2 px-4 text-sm text-gray-700']">{{ item.name }}</a>
                  <a v-else :className="item.id"
                     :class="[active ? 'bg-gray-100' : '', 'block py-2 px-4 text-sm text-gray-700']" :href="item.href">{{
                      item.name
                    }}</a>
                </MenuItem>
              </MenuItems>
            </transition>
          </Menu>
        </div>-->
        <div class="hidden lg:relative lg:z-10 lg:ml-4 lg:flex lg:items-center">


          <SearchModal></SearchModal>

            <Menu as="div" class="relative text-left">
                <MenuButton :class="[languageMenu.current ? 'bg-gray-900 text-white' :
              'text-gray-300 hover:bg-gray-700 hover:text-white',
           'rounded-md py-2 px-3 inline-flex items-center text-sm font-medium']">
                    <span>{{ languageMenu.name }}</span>
                    <ChevronDownIcon class="ml-1 h-5 w-5 text-gray-500" aria-hidden="true"/>
                </MenuButton>

                <transition enter-active-class="transition ease-out duration-100"
                            enter-from-class="transform opacity-0 scale-95"
                            enter-to-class="transform opacity-100 scale-100"
                            leave-active-class="transition ease-in duration-75"
                            leave-from-class="transform opacity-100 scale-100"
                            leave-to-class="transform opacity-0 scale-95">
                    <MenuItems class="apply-dropdown-wrap">
                        <div class="py-1">
                            <MenuItem v-for="child in languageMenu.children" :key="child.id" v-slot="{ active }">
                                <a :href="child.href"
                                   :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']">
                                    {{ child.name }}
                                </a>
                            </MenuItem>
                        </div>
                    </MenuItems>
                </transition>
            </Menu>

          <template v-if="isMember">
            <a href='/live'
               class="bg-yellow-500 text-black mr-4
               rounded-md py-2 px-3 inline-flex items-center text-sm font-medium">Live</a>
          </template>

          <template v-if="hasVenue">
            <a href="/site"
               class="bg-sky-200 text-black mr-4
               rounded-md py-2 px-3 inline-flex items-center text-sm font-medium">Venue</a>
          </template>

          <template v-if="isMember">
            <a href="/dash/session/favorites"
               class="bg-gray-800 flex-shrink-0 rounded-full p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
              <span class="sr-only">View favorites</span>
              <HeartIcon class="h-6 w-6" aria-hidden="true"/>
            </a>

            <!-- Profile dropdown MAIN MENU-->
            <Menu as="div" class="flex-shrink-0 relative ml-4">
              <div>
                <MenuButton
                    dusk="avatar-menu-button"
                    class="bg-gray-800 rounded-full flex text-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                  <span class="sr-only">Open user menu</span>
                  <img class="h-8 w-8 rounded-full" :src="imageUrl" alt=""/>
                </MenuButton>
              </div>
              <transition enter-active-class="transition ease-out duration-100"
                          enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                          leave-active-class="transition ease-in duration-75"
                          leave-from-class="transform opacity-100 scale-100"
                          leave-to-class="transform opacity-0 scale-95">
                <MenuItems
                    class="menu-dropdown origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 py-1 focus:outline-none">
                  <MenuItem v-for="item in userNavigation" :key="item.id" v-slot="{ active }">
                    <hr v-if="item.divider">
                    <a v-else-if="item.post" @click="postRequest(item.post)"
                       :className="item.id"
                       :class="[active ? 'bg-gray-100' : '', 'block py-2 px-4 text-sm text-gray-700']">{{ item.name }}</a>
                    <a v-else :className="item.id"
                       :class="[active ? 'bg-gray-100' : '', 'block py-2 px-4 text-sm text-gray-700']" :href="item.href">{{
                        item.name
                      }}</a>
                  </MenuItem>
                </MenuItems>
              </transition>
            </Menu>
          </template>

          <template v-if="eventJoinMenus.length" v-for="joinMenu in eventJoinMenus">
            <a :href='joinMenu.href'
               :class="[menuClass(joinMenu.importance) ,'apply-menu-items-1']">
              {{ joinMenu.name }}</a>
          </template>

          <template v-else-if="siteJoinMenus.length" v-for="joinMenu in siteJoinMenus">
            <a :href='joinMenu.href'
               :class="[menuClass(joinMenu.importance) ,'apply-menu-items-1']">
              {{ joinMenu.name }}</a>
          </template>
        </div>
      </div>
      <nav class="hidden lg:py-2 lg:flex lg:space-x-5" aria-label="Global">
<!--        <a v-for="item in menus" :key="item.name" :href="item.href"
           :class="[item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
           'rounded-md py-2 px-3 inline-flex items-center text-sm font-medium']"
           :aria-current="item.current ? 'page' : undefined">
          {{ item.name }}
        </a>-->

        <template v-for="item in menus" :key="item.name">
          <Menu v-if="item.children.length" as="div" class="relative text-left">
            <MenuButton :class="[item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
           'apply-menu-dropdown-base']">
              <span>{{ item.name }}</span>
              <ChevronDownIcon class="ml-1 h-5 w-5 text-gray-500" aria-hidden="true"/>
            </MenuButton>

            <transition enter-active-class="transition ease-out duration-100"
                        enter-from-class="transform opacity-0 scale-95"
                        enter-to-class="transform opacity-100 scale-100"
                        leave-active-class="transition ease-in duration-75"
                        leave-from-class="transform opacity-100 scale-100"
                        leave-to-class="transform opacity-0 scale-95">
              <MenuItems class="menu-dropdown origin-top-right absolute z-30 right-0 mt-2 w-40 rounded-md shadow-lg
              bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div class="py-1">
                  <MenuItem v-for="child in item.children" :key="child.id" v-slot="{ active }">
                    <a :href="child.href"
                       :class="[active ? 'bg-gray-100' : '', 'apply-menu-dropdown-child-base']">
                      {{ child.name }}
                    </a>
                  </MenuItem>
                </div>
              </MenuItems>
            </transition>
          </Menu>
          <a v-else :href="item.href" :class="[item.current ? 'apply-menu-main-base-current' : 'apply-menu-main-base-not-current',
           'apply-menu-main-base']">{{ item.name }}</a>
        </template>

      </nav>
    </div>

    <DisclosurePanel as="nav" class="lg:hidden" aria-label="Global">
      <div class="pt-2 pb-3 px-2 space-y-1">
        <div v-for="item in menus" :key="item.name" :href="item.href">

          <div v-if="item.children.length">
            <span class="block rounded-md py-2 px-3 text-base font-medium text-white">## {{ item.name }}</span>
            <a v-for="child in item.children" :href="child.href" :key="child.name"
               class="block rounded-md py-2 px-3 text-base font-medium text-gray-400
                hover:bg-gray-700 hover:text-white">{{ child.name }}</a>
          </div>
            <a v-else
               :href="item.href"
               :class="[item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white', 'block rounded-md py-2 px-3 text-base font-medium']"
               :aria-current="item.current ? 'page' : undefined">{{ item.name }}</a>
        </div>
      </div>
        <div v-if="isMember  || hasVenue" class="border-t border-gray-700 pb-3">
            <div class="mt-3 px-2 space-y-1">
                <a v-if="isMember" href="/live" class="block rounded-md py-2 px-3 text-base font-medium text-gray-400
                hover:bg-gray-700 hover:text-white">Live</a>
                <a v-if="hasVenue" href="/site" class="block rounded-md py-2 px-3 text-base font-medium text-gray-400
                hover:bg-gray-700 hover:text-white">Venue</a>
                <Menu as="div" class="relative text-left">
                    <MenuButton :class="[languageMenu.current ? 'bg-gray-900 text-white' :
              'text-gray-300 hover:bg-gray-700 hover:text-white',
           'rounded-md py-2 px-3 inline-flex items-center text-sm font-medium']">
                        <span>{{ languageMenu.name }}</span>
                        <ChevronDownIcon class="ml-1 h-5 w-5 text-gray-500" aria-hidden="true"/>
                    </MenuButton>
                    <transition enter-active-class="transition ease-out duration-100"
                                enter-from-class="transform opacity-0 scale-95"
                                enter-to-class="transform opacity-100 scale-100"
                                leave-active-class="transition ease-in duration-75"
                                leave-from-class="transform opacity-100 scale-100"
                                leave-to-class="transform opacity-0 scale-95">
                        <MenuItems class="apply-dropdown-wrap">
                            <div class="py-1">
                                <MenuItem v-for="child in languageMenu.children" :key="child.id" v-slot="{ active }">
                                    <a :href="child.href"
                                       :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']">
                                        {{ child.name }}
                                    </a>
                                </MenuItem>
                            </div>
                        </MenuItems>
                    </transition>
                </Menu>
            </div>
      </div>
      <div class="border-t border-gray-700 pt-4 pb-3">
        <div v-if="isUser" class="px-4 flex items-center">
          <div class="flex-shrink-0">
            <img class="h-10 w-10 rounded-full" :src="imageUrl" alt=""/>
          </div>
          <div class="ml-3">
            <div class="text-base font-medium text-white">{{ user.name }}</div>
            <div class="text-sm font-medium text-gray-400">{{ user.email }}</div>
          </div>
          <template v-if="isMember">
                   <a href="/dash/session/favorites"
                       class="ml-auto flex-shrink-0 bg-gray-800 rounded-full p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
            <span class="sr-only">View favorites</span>
            <HeartIcon class="h-6 w-6" aria-hidden="true"/>
                   </a>
          </template>
        </div>
        <!-- USER NAV IN MOBILE -->
        <div class="mt-3 px-2 space-y-1">
          <template v-if="userNavigation.length" v-for="item in userNavigation" :key="item.name">
            <a @click="postRequest(item.post)" v-if="item.post"
               class="block rounded-md py-2 px-3 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white">{{
                item.name
              }}</a>
            <a v-else :href="item.href"
               class="block rounded-md py-2 px-3 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white">{{
                item.name
              }}</a>
          </template>
          <template v-else>
            <a :href="links.login"
               class="block rounded-md py-2 px-3 text-base font-medium text-gray-400
               hover:bg-gray-700 hover:text-white">Login</a>
            <a :href="links.siteJoin"
               class="block rounded-md py-2 px-3 text-base font-medium text-gray-400
               hover:bg-gray-700 hover:text-white">Join</a>
          </template>
        </div>
      </div>
    </DisclosurePanel>
  </Disclosure>
</template>

<script>
import {ref} from 'vue'
import {Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/vue'
import {
  ArchiveIcon as ArchiveIconSolid,
  ChevronDownIcon,
  ChevronUpIcon,
  DotsVerticalIcon,
  FolderDownloadIcon,
  PencilIcon,
  ReplyIcon,
  SearchIcon,
  UserAddIcon,
} from '@heroicons/vue/solid'
import {BellIcon, MenuIcon, XIcon, HeartIcon} from '@heroicons/vue/outline'

import SearchModal from "./SearchModal";

import {library} from '@fortawesome/fontawesome-svg-core';
//import {faCoffee as fasCoffee} from '@fortawesome/pro-solid-svg-icons';
import {faUserAstronaut as fasUserAstronaut} from '@fortawesome/pro-solid-svg-icons'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import _ from "lodash";
//library.add(fasCoffee);
library.add(fasUserAstronaut);

/*
<font-awesome-icon :icon="['fas', 'user-astronaut']"></font-awesome-icon>
*/

/*const user = {
  name: 'Tom Cook',
  email: 'tom@example.com',
  imageUrl:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
}*/



export default {
  components: {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    BellIcon,
    MenuIcon,
    SearchIcon,
    XIcon,
    ChevronDownIcon,
    HeartIcon,
    FontAwesomeIcon,
    SearchModal
  },
  methods: {
    postRequest(path) {

      axios.post(path)
          .then(function (response) {
            //const status = JSON.parse(response.data.response.status);



            if (response.status == '204' || response.status == '200') {
              window.location = '/logging/logged-out';
              return;
            }
            //redirect logic
          })
          .catch(error => {
            // console.log(error.response.data.error)
          })
    },
    menuClass(importance) {
      if (importance === 'high') {
        return 'bg-red-900';
      }
      if (importance === 'critical') {
        return 'bg-red-900';
      }
      return 'bg-gray-900';
    }
  },
  props: {
    user: Object,
    member: Object,
    event: Object,
    eventJoinMenus: Array,
    siteJoinMenus: Array,
    languageMenu: Object,
    menus: Array,
    navigation: Array,
    unverified: {
      'type': Boolean,
      'default': false
    },
    hasVenue: {
      'type': Boolean,
      'default': false
    },
    links: {
      'type': Object,
      'default': {
        'siteJoin': '/register',
        'eventJoin': '/event/join',
        'login': '/login'
      }
    }
  },
  setup(props) {
    const open = ref(false)
    const isUnverified = props.unverified;
    const user = props.user;
    const member = props.member;
    const event = props.event;
    const userNavigation = props.navigation;
    const eventJoinMenus = props.eventJoinMenus;
    const siteJoinMenus = props.siteJoinMenus;
    const languageMenu = props.languageMenu;
    let eventName = '';
    let eventLink = '';
    const menus = props.menus;
    //let userNavigation = [];
    let isUser = false;
    let isMember = false;
    let hasVenue = props.hasVenue;
    let imageUrl = '';

    const links = props.links;


    // user but not member

    // not logged in


    if (!_.isEmpty(user) && !_.isEmpty(member)) { // USER and MEMBER
      /*userNavigation = [
        {name: 'Your Profile', href: '#'},
        {name: 'Global Settings', href: '/global/settings'},
        {name: 'Sign out', href: '#'},
      ];*/
      isUser = true;
      isMember = true;
      imageUrl = member.avatar_path;
    }else if (!_.isEmpty(user) && _.isEmpty(member)) { // USER but not member
      /*userNavigation = [
        {name: 'Your Profile', href: '#'},
        {name: 'Global Settings', href: '/global/settings'},
        {name: 'Sign out', href: '#'},
      ];*/
      isUser = true;
      isMember = false;
      imageUrl = '/img/user-astronaut-square.png';
    } else {
      //userNavigation = [];
      isUser = false;
      isMember = false;
    }

    return {
      user,
      menus,
      userNavigation,
      eventJoinMenus,
      siteJoinMenus,
      languageMenu,
      open,
      imageUrl,
      isUser,
      isMember,
      links,
      isUnverified,
      hasVenue
    }

    /*
    if (_.isEmpty(user)) {

    }


    if (_.isEmpty(member)) {

      eventName = 'Join ' + event.name;
      eventLink = '/join';
      isUser = false;
      userNavigation = [];

    } else {
      eventName = event.name;
      eventLink = '/';
      userNavigation = [
        {name: 'Your Profile', href: '#'},
        {name: 'Global Settings', href: '/global/settings'},
        {name: 'Sign out', href: '#'},
      ]
    }

    isUser = '';

    const imageUrl = member.avatar_path;
    */

    /*menus = [
      {name: eventName, href: eventLink, current: true},
      {name: 'Sessions', href: '#', current: false},
      {name: 'Live', href: '#', current: false},
      {name: 'Team', href: '#', current: false},
      {name: 'Attendees', href: '#', current: false},
      {name: 'Help', href: '#', current: false},
    ]*/


  },
}
</script>

<style>
/* block py-2 px-4 text-sm text-gray-700 */
/*
.menu-dropdown a {
  display: block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;

}
*/
</style>
